<template>
  <section class="previous">
    <div class="previous__wrapper">
      <BaseTitle class="previous__title" :text="title" :tag="'h1'" />
      <div class="previous__years_block" ref="block">
        <div class="previous__controls" v-show="!disableControls">
          <button class="previous__controls-left" @click="scrollWrapper('prev')"></button>
          <button class="previous__controls-right" @click="scrollWrapper('next')"></button>
        </div>
        <div ref="years" class="previous__years">
          <div class="previous__years_wrapper" ref="wrapper">
            <div
              v-for="(year, i) in allYears"
              :key="i"
              :data-year="year"
              @click="toggleYear"
              :class="[
            `previous__year previous__year--${extractNumber(year)}`,
            { 'previous__year--active' : activeYear === year }
          ]"
            >
              <span>{{ extractNumber(year) }}</span>
            </div>
          </div>
        </div>
      </div>
      <PreviousContestCategory :year="currentYear" />
    </div>
  </section>
</template>

<script>
import { Helper } from '~/mixins/Helper'
import ShapeYearBtn1Mob from '~/components/_SVG/ShapeYearBtn1Mob.vue'
import ShapeYearBtn2Mob from '~/components/_SVG/ShapeYearBtn2Mob.vue'
import ShapeYearBtn3Mob from '~/components/_SVG/ShapeYearBtn3Mob.vue'
import ShapeYearBtn4Mob from '~/components/_SVG/ShapeYearBtn4Mob.vue'
import ShapeYearBtn1Tab from '~/components/_SVG/ShapeYearBtn1Tab.vue'
import ShapeYearBtn2Tab from '~/components/_SVG/ShapeYearBtn2Tab.vue'
import ShapeYearBtn3Tab from '~/components/_SVG/ShapeYearBtn3Tab.vue'
import ShapeYearBtn4Tab from '~/components/_SVG/ShapeYearBtn4Tab.vue'
import PreviousContestCategory from '~/components/PreviousContestCategory.vue'

export default {
  data() {
    return {
      activeClass: 'previous__year--active',
      activeYear: this.initial_year,
      disableControls: false,
      scrollLeft: 0
    }
  },
  components: {
    ShapeYearBtn1Mob,
    ShapeYearBtn2Mob,
    ShapeYearBtn3Mob,
    ShapeYearBtn4Mob,
    ShapeYearBtn1Tab,
    ShapeYearBtn2Tab,
    ShapeYearBtn3Tab,
    ShapeYearBtn4Tab,
    PreviousContestCategory
  },
  props: {
    title: {
      type: String,
      required: true
    },
    winners: {
      type: Object,
      required: true
    },
    initial_year: {
      type: String
    }
  },
  computed: {
    currentYear() {
      return this.winners[this.activeYear] || {}
    },
    sortedArr() {
      return Object.keys(this.winners).sort()
    },
    allYears() {
      return this.sortedArr
    }
  },
  mounted() {
    const wrapper = this.$refs.wrapper
    const container = this.$el.querySelector('.previous__years')
    const active = this.$el.querySelector('.previous__year--active')

    if (wrapper.clientWidth <= container.clientWidth) {
      this.disableControls = true
    }

    if (container && active) {
      container.scrollLeft = active.offsetLeft

      this.scrollLeft = container.scrollLeft
    }
  },
  mixins: [Helper],
  methods: {
    toggleYear(evt) {
      const { target } = evt

      if (this.allYears.includes(target.dataset.year)) {
        const years = [...this.$refs.years.childNodes]

        years.forEach(year => year.classList.remove(this.activeClass))

        this.activeYear = target.dataset.year
      }
    },
    scrollWrapper(v) {
      const container = this.$el.querySelector('.previous__years')
      const wrapper = this.$refs.block
      const year = this.$el.querySelector('.previous__year')
      let val = year.clientWidth
      if (v === 'prev') {
        val *= -1
      }

      if (this.scrollLeft + val < 0) {
        container.scrollLeft = 0
        this.scrollLeft = 0
      } else if (this.scrollLeft + val > (container.scrollWidth - wrapper.clientWidth)) {
        container.scrollLeft = container.scrollWidth
        this.scrollLeft = container.scrollWidth - wrapper.clientWidth
      } else {
        container.scrollLeft = this.scrollLeft + val
        this.scrollLeft += val
      }
    },
    extractNumber(str) {
      return str.match(/\d+/g)[0]
    }
  }
}
</script>

<style lang="scss">
.previous {
  &__wrapper {
    @include container;

    position: relative;
    padding: 66px 16px 32px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 350px;
      left: -17px;
      width: 458px;
      height: 373px;
      background: url('~/static/img/previous-contest-bg@mb.svg') no-repeat
        center;
      background-size: cover;
    }
  }

  &__title {
    margin: 0 0 20px;
  }

  &__years {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 33px;
    overflow-y: scroll;

    @include custom-scroll(true);

    &_block {
      position: relative;
    }

    &_wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__controls {
    position: absolute;
    width: 100%;
    height: 100%;

    &-left,
    &-right {
      outline: none;
      border: none;
      top: 50%;
      transform: translateY(-50%);
      transform-origin: center center;
      cursor: pointer;
    }

    &-left {
      position: absolute;
      left: -50px;
      width: 40px;
      height: 40px;
      background: url('~/static/img/arrow.svg') no-repeat center;
      transform: rotate(180deg) translateY(50%);

      @include media-max($desktop-width) {
        left: -25px;
      }

      @include media-max($mobile-width-only) {
        left: -30px;
      }
    }

    &-right {
      position: absolute;
      right: -50px;
      width: 40px;
      height: 40px;
      background: url('~/static/img/arrow.svg') no-repeat center;

      @include media-max($desktop-width) {
        right: -25px;
      }

      @include media-max($mobile-width-only) {
        right: -30px;
      }
    }
  }

  &__year {
    position: relative;
    flex: 1 0 auto;
    width: 170px;
    height: 70px;
    margin: 0 10px;
    opacity: 0.4;
    cursor: pointer;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    @include media-max($desktop-width) {
      width: 100px;
      height: 40px;
    }

    @include media-max($tablet-width) {
      width: 80px;
      height: 40px;
    }

    &:nth-of-type(-n + 2) {
      margin-bottom: 7px;
    }

    $items: (
      1: (
        background-image: url('~/static/img/previous-contest-shape-button-1.svg'),
      ),
      2: (
        background-image: url('~/static/img/previous-contest-shape-button-2.svg'),
      ),
      3: (
        background-image: url('~/static/img/previous-contest-shape-button-3.svg'),
      ),
      4: (
        background-image: url('~/static/img/previous-contest-shape-button-4.svg'),
      ),
      5: (
        background-image: url('~/static/img/previous-contest-shape-button-1.svg'),
      ),
      6: (
        background-image: url('~/static/img/previous-contest-shape-button-2.svg'),
      ),
      7: (
        background-image: url('~/static/img/previous-contest-shape-button-3.svg'),
      ),
      8: (
        background-image: url('~/static/img/previous-contest-shape-button-4.svg'),
      )
    );

    @include generator($items);

    &--active {
      opacity: 1;
    }

    svg,
    span {
      @include easeOut;

      pointer-events: none;
    }

    span {
      @include absolute-center;

      position: absolute;
      color: #282830;
      font-family: $OpenSans;
      font-size: 15px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  &__item {
    &:not(:last-of-type) {
      margin-bottom: 50px;
    }
  }

  &__caption {
    margin: 0 0 19px;
    color: #595d60;
    font-family: $ToyotaType;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  .glide {
    &__caption {
      margin: 0 0 2px;
    }

    &__text {
      margin: 0 0 16px;
    }

    &__img {
      display: block;
      width: 100%;
      height: 242px;
      object-fit: cover;
    }
  }
}

@include media-min($tablet-width) {
  .previous {
    &__wrapper {
      padding: 96px 25px 142px;

      &::before {
        top: 373px;
        left: -197px;
        width: 1095px;
        height: 1460px;
        background: url('~/static/img/previous-contest-bg@tl.svg') no-repeat
          center;
        background-size: cover;
      }
    }

    &__title {
      margin-bottom: 40px;
    }

    &__years {
      position: relative;
      margin-bottom: 62px;
    }

    &__year {
      height: 70px;

      &:nth-of-type(-n + 2) {
        margin-bottom: 0;
      }

      $items: (
        1: (
          background-image: url('~/static/img/previous-contest-shape-button-1@tl.svg'),
        ),
        2: (
          background-image: url('~/static/img/previous-contest-shape-button-2@tl.svg'),
        ),
        3: (
          background-image: url('~/static/img/previous-contest-shape-button-3@tl.svg'),
        ),
        4: (
          background-image: url('~/static/img/previous-contest-shape-button-4@tl.svg'),
        ),
        5: (
          background-image: url('~/static/img/previous-contest-shape-button-1@tl.svg'),
        ),
        6: (
          background-image: url('~/static/img/previous-contest-shape-button-2@tl.svg'),
        ),
        7: (
          background-image: url('~/static/img/previous-contest-shape-button-3@tl.svg'),
        ),
        8: (
          background-image: url('~/static/img/previous-contest-shape-button-4@tl.svg'),
        )
      );

      @include generator($items);
    }

    &__item {
      width: 560px;
      margin: 0 auto;

      &:not(:last-of-type) {
        margin-bottom: 60px;
      }
    }

    &__caption {
      margin-bottom: 20px;
      font-size: 20px;
      line-height: 23px;
    }

    .glide {
      &__arrow {
        top: 170px;

        &--left {
          left: -180px;
        }

        &--right {
          right: -180px;
        }
      }

      &__img {
        display: block;
        height: 380px;
      }
    }
  }
}

@include media-min($desktop-width) {
  .previous {
    &__wrapper {
      padding: 124px 60px 111px;

      &::before {
        top: 422px;
        left: -211px;
        width: 1757px;
        height: 2270px;
        background-size: cover;
      }
    }

    &__item {
      width: 878px;
    }

    &__caption {
      margin-bottom: 36px;
    }

    &__year {
      height: 89px;

      $items: (
        1: (
          background-image: url('~/static/img/previous-contest-shape-button-1@dt.svg'),
        ),
        2: (
          background-image: url('~/static/img/previous-contest-shape-button-2@dt.svg'),
        ),
        3: (
          background-image: url('~/static/img/previous-contest-shape-button-3@dt.svg'),
        ),
        4: (
          background-image: url('~/static/img/previous-contest-shape-button-4@dt.svg'),
        ),
        5: (
          background-image: url('~/static/img/previous-contest-shape-button-1@dt.svg'),
        ),
        6: (
          background-image: url('~/static/img/previous-contest-shape-button-2@dt.svg'),
        ),
        7: (
          background-image: url('~/static/img/previous-contest-shape-button-3@dt.svg'),
        ),
        8: (
          background-image: url('~/static/img/previous-contest-shape-button-4@dt.svg'),
        )
      );

      @include generator($items);
    }

    .glide {
      &__arrow {
        top: 240px;

        &--left {
          left: -315px;
        }

        &--right {
          right: -315px;
        }
      }

      &__img {
        height: 598px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/PreviousContestBlock.vue